export default __webpack_public_path__ + "static/media/exe.275d65bb.jfif";